import PropTypes from 'prop-types';
import { useState } from 'react';
import Api from '../../../utils/api';
import EmailSms from 'components/EmailSms';

import translating from '../translate.json';
import Button from '../../Button';

const ResetPassword = ({ mobile, email, handleChangeMode }) => {
  const [currentType, setType] = useState(['Sms', 'eMail']);
  const types = ['EmailSms', 'Sms', 'eMail'];
  const [showMessage, setShowMessage] = useState();

  const handleSendMsg = () => {
    Api.post('auth/clientForgotPassword', {
      email: email,
      messageType: currentType?.length > 1 ? types[0] : currentType[0]
    }).then((res) => {
      if (res?.status == 201) {
        setTimeout(() => {
          setShowMessage(false);
          handleChangeMode(null);
        }, 4000);
        setShowMessage(true);
      }
    });
  };

  return (
    <div className="reset-password">
      <div className="send-sms-target">
        <div className="send-sms-target-title">{translating.sendTarget} </div>
        <EmailSms
          mobile={mobile}
          email={email}
          handleSetType={(type) => setType(type)}
        ></EmailSms>
      </div>
      <div className="wrapper-send-btn">
        <Button
          disable={showMessage}
          txt={translating.send}
          handleClick={handleSendMsg}
        ></Button>
      </div>
      {showMessage && (
        <div className="succsses-msg">{translating.resetPasswordSent}</div>
      )}
    </div>
  );
};

export default ResetPassword;

ResetPassword.propTypes = {
  email: PropTypes.string,
  mobile: PropTypes.string,
  handleChangeMode: PropTypes.func
};
